<template>
    <v-container fluid class="d-flex flex-column pa-2" style="width: 100vw">
        <v-window v-model="step" horizontal style="max-height: calc(100vh - 133px)">
            <v-window-item :key="0">
                <v-row no-gutters>
                    <v-col
                        cols="12"
                        class="d-flex flex-column align-center justify-center pb-3 pb-2"
                    >
                        <div class="d-flex title justify-space-between">
                            {{ formatCategory(document.type) }}
                        </div>
                        <div class="text--secondary" v-if="document.invoiceNumber">
                            Facture n&#xb0;{{ document.invoiceNumber }}
                        </div>
                    </v-col>
                    <v-col cols="12" class="pa-2 mb-2 oss-list-item">
                        <v-row no-gutters>
                            <v-col class="py-2 pl-3">
                                <div class="text-secondary font-weight-regular pr-1">
                                    Status | {{ documentStatus }}
                                </div>
                                <!-- <div class="subtitle-1 font-weight-medium">
                                    {{ documentStatus }}
                                </div> -->
                            </v-col>
                            <!-- <v-col
                                cols="6"
                                class="d-flex align-center py-2 pl-3"
                                v-if="reconciliationCallToAction && isAccountingUser"
                            >
                                <v-btn
                                    rounded
                                    elevation="0"
                                    :disabled="disabledCallToAction"
                                    @click="openReconciliation()"
                                    size="small"
                                >
                                    {{ reconciliationCallToAction }}
                                </v-btn>
                            </v-col> -->
                        </v-row>
                    </v-col>
                    <v-col
                        cols="12"
                        class="pa-2 mb-2 pl-5 oss-list-item"
                        v-if="showThirdPartyCompany"
                    >
                        <div class="font-weight-medium">
                            {{ document.thirdPartyCompany ? document.thirdPartyCompany.name : "" }}
                        </div>
                        <div class="caption text--secondary pt-1">
                            Siret :
                            {{
                                document.thirdPartyCompany && document.thirdPartyCompany.siret
                                    ? getSiretValue(document.thirdPartyCompany.siret)
                                    : ""
                            }}
                        </div>
                        <div class="caption text--secondary">Adresse : {{ fullAddress }}</div>
                    </v-col>
                    <v-col cols="12" class="pa-2 mb-2 oss-list-item">
                        <v-row no-gutters>
                            <v-col class="d-flex flex-column py-2 pl-3">
                                <div class="text--secondary font-weight-regular">
                                    Date du document
                                </div>
                                <div class="subtitle-1 font-weight-medium">
                                    {{ formatDate(document.date) }}
                                </div>
                            </v-col>
                            <v-col
                                cols="6"
                                class="d-flex flex-column py-2 pl-3 border-left"
                                v-if="dueDateEnable"
                            >
                                <div class="text--secondary font-weight-regular">
                                    {{ $t("shared.dueDate") }}
                                </div>
                                <div class="subtitle-1 font-weight-medium">
                                    {{ formatDate(dueDate) }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="py-2 mb-2 oss-list-item" v-if="showDetail">
                        <accounting-item-static
                            :companyId="companyId"
                            :documentId="document.id"
                            @update="startToBeDoneIfNecessary"
                            mode="Payment"
                        />
                    </v-col>
                    <v-col
                        cols="12"
                        class="pa-2 mb-2 oss-list-item"
                        v-if="activateTagguing && document.type !== 'EXPENSE_REPORT_DOCUMENT'"
                    >
                        <v-row no-gutters>
                            <v-col cols="12">
                                <FreeTag
                                    :companyTags="allCompanyTags"
                                    :document="inDocument"
                                    :outlined="true"
                                    @changed="startToBeDoneIfNecessary"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item :key="1">
                <div style="max-height: calc(100vh - 133px); overflow: auto">
                    <ossPdf v-if="isPDF" :documentId="document.id" />
                    <div
                        v-else
                        class="document-display"
                        :style="{
                            backgroundImage: `url(${document.signedUrl})`,
                            height: `calc(${imageHeight} * calc(100vw - 16px) / ${imageWidth})`,
                        }"
                    />
                </div>
            </v-window-item>
        </v-window>

        <v-row no-gutters class="pa-2" v-if="document.signedUrl">
            <v-col cols="12" class="d-flex justify-center">
                <v-btn rounded elevation="0" style="width: 55%" @click="onStep()" size="small">
                    {{ step ? "Voir les informations" : "Voir le document" }}
                </v-btn>
            </v-col>
        </v-row>
        <Chat
            v-if="openChat"
            :id="document.chat ? document.chat.id : ''"
            :status="'INFORMATION_REQUEST'"
        />
    </v-container>
</template>

<script lang="ts">
import { getSiretValue } from "../../../src/services/companyServices";
import { DocumentStatic } from "./DocumentStatic.vue";
import ossPdf from "./DocumentPDF.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        ossPdf,
    },
})
export class DocumentStaticMobile extends DocumentStatic {
    onStep() {
        this.step = this.step ? 0 : 1;
    }

    get filtredPrices() {
        if (this.prices?.length === 1) {
            return this.prices;
        }
        return this.prices?.filter((price) => !price.total) || [];
    }

    get total() {
        return this.prices?.find((price) => price.total) || {};
    }

    get showThirdPartyCompany() {
        return (
            this.document.type === "PURCHASE_INVOICE" ||
            this.document.type === "SALES_INCOICE" ||
            this.document.type === "EXPENSE_REPORT_DOCUMENT"
        );
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }

    // get showTotal() {
    //     if ((this.inDocument.status==='VALIDATED' || this.inDocument.status==='ANALYSED') && !this.inDocument.accountingLinesLocked) {
    //         if (this.inDocument.type === "PURCHASE_INVOICE" && this.inDocument.type === "PURCHASE_INVOICE") return true
    //     }
    //     return false
    // }
}

export default toNative(DocumentStaticMobile);
</script>
<style lang="scss" scoped>
.document-display {
    background-color: #fff;
    background-size: cover;
    width: calc(100vw - 16px);
    height: calc(100vh - 180px);
}

.border-left {
    border-left: 1px solid rgba(0, 0, 0, 0.12);
}

.tax-price:nth-child(2n) {
    background-color: #fff;
    border: none;
}

.tax-price:nth-child(2n + 1) {
    background-color: #fef8ee;
    border: none;
}
</style>
